export enum TransactionDetailsTab {
  GENERAL = 'general',
  FUNDING_SUMMARY = 'funding-summary',
  FUNDING_DETAIL = 'funding-detail',
  STATISTICS = 'statistics',
  WALLETS = 'wallets',
  BONUS = 'bonus',
  LINKS = 'links',
  NOTES = 'notes',
  DEALS = 'deals',
  LOTS_PROFIT_STATS = 'lots-profit-statistics',
}
